import React from "react";
import { Section, SectionTitle } from "./DetailsStyles";

export default function Location() {
  return (
    <Section>
      <SectionTitle>Standort</SectionTitle>
      <p>📍132 A, Joshi Marg, Kalwar Rd, Sanjay Nagar, Jhotwara, Jaipur, Rajasthan 302012</p>
    </Section>
  );
}
